import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "utils/useDidMountEffect";
import apiUser from "apiUser";
import Select from "componentsReusable/Select";
import {useTecRmi} from "../../../contexts/TecRmiContext";

const BodyForMaintenancesSelect = props => {
  const { getApiPrimaryParams } = useTecRmi()
  const [bodiesForMaintenances, setBodiesForMaintenances] = useState([])

  useDidMountEffect(() => {
    apiUser.tecRmi.maintenance.bodiesForMaintenance(getApiPrimaryParams())
      .then(res => {
        setBodiesForMaintenances(res.data)
        if(res.data.length === 1){
          props.onChange(res.data[0].QualColId)
        }
      })
  })

  return (
    bodiesForMaintenances.length > 1 && <Select
      onChange={props.onChange}
      options={bodiesForMaintenances.map(bodyForMaintenances => ({
        label: bodyForMaintenances.QualColText,
        value: bodyForMaintenances.QualColId,
      }))}
    />
  );
};

BodyForMaintenancesSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
};

export default BodyForMaintenancesSelect;